// In-app browser (WebView) detection + best-effort hand-off to the real browser.
// Instagram / Facebook / TikTok & co. have no Web Push support, so we only use
// this to show a small notice and offer an "Open in browser" escape hatch.

const DISMISS_KEY = "spotdrop_inapp_notice_dismissed";

const PATTERNS = [
  [/Instagram/i, "Instagram"],
  [/FBAN|FBAV|FB_IAB|FBIOS/i, "Facebook"],
  [/Messenger/i, "Messenger"],
  [/TikTok|BytedanceWebview|musical_ly/i, "TikTok"],
  [/Twitter/i, "X"],
  [/\bLine\//i, "LINE"],
  [/Snapchat/i, "Snapchat"],
];

export function inAppBrowserName() {
  if (typeof navigator === "undefined") return null;
  const ua = navigator.userAgent || "";
  for (const [re, name] of PATTERNS) if (re.test(ua)) return name;
  return null;
}

export function isInAppBrowser() {
  return !!inAppBrowserName();
}

export function noticeDismissed() {
  try {
    return localStorage.getItem(DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissNotice() {
  try {
    localStorage.setItem(DISMISS_KEY, "1");
  } catch {
    /* ignore */
  }
}

async function copyCurrentUrl(notify) {
  const url = window.location.href;
  try {
    await navigator.clipboard.writeText(url);
    notify("success", "Link copied \u2014 tap \u2022\u2022\u2022 and choose \u201COpen in browser\u201D.");
  } catch {
    notify("message", "Tap \u2022\u2022\u2022 in this app and choose \u201COpen in browser\u201D.");
  }
}

/** Android: hands off to Chrome via an intent URL, falling back to copy when
 *  Chrome is unavailable (we are still on the page a moment later).
 *  iOS / anything else: copies the link, since no API can leave a WebView. */
export function openInExternalBrowser(notify) {
  const say = typeof notify === "function" ? notify : () => {};
  const isAndroid = /Android/i.test(navigator.userAgent || "");
  if (!isAndroid) {
    copyCurrentUrl(say);
    return;
  }
  const { host, pathname, search } = window.location;
  const intent = `intent://${host}${pathname}${search}#Intent;scheme=https;package=com.android.chrome;end`;
  const startedAt = Date.now();
  try {
    window.location.href = intent;
  } catch {
    copyCurrentUrl(say);
    return;
  }
  window.setTimeout(() => {
    // Chrome never took over — stay useful instead of failing silently.
    if (document.visibilityState === "visible" && Date.now() - startedAt >= 1200) {
      copyCurrentUrl(say);
    }
  }, 1400);
}
